// EN
export const hotelCalendarHc = {
  toolbar: {
    bulkEdit: "Sammelbearbeitung",
    cfgTitle: "Kalendereinstellungen",
    syncSection: "Synchronisierung",
    resyncOta: "Erneut mit OTA synchronisieren",
    resyncOtaSub: "Verfügbarkeit und Raten erneut an den Kanal senden.",
  },
  mode: {
    calendar: "Kalender",
    rates: "Raten",
  },
  search: {
    placeholder: "Gast oder Code suchen…",
    clear: "Leeren",
    go: "Suchen",
    resultsHint: "{count} Ergebnisse, wählen Sie eines aus:",
    combo: "Kombiniert · {count} Zimmer",
  },
  header: {
    occupancy: "Belegung {pct} %",
  },
  type: {
    roomsAbbr: "Zimmer",
    configTitle: "Einstellungen des Zimmertyps (OTA sowie An- und Abreiseregeln)",
    otaConnected: "OTA verbunden",
    subscribeToConnect: "Abonnement abschließen, um OTAs zu verbinden",
  },
  rtCell: {
    editTooltip: "Klicken, um Verfügbarkeit, Preis, Mindestaufenthalt und Schließung zu bearbeiten",
    overbookRisk: "Überbuchungsrisiko",
    closedTag: "Geschlossen",
  },
  rules: {
    sameDayCutoff: "Verkaufsschluss für denselben Tag um {time}",
  },
  organizeRow: {
    title: "Zu ordnen",
    unplacedCount: "{count} nicht zugeordnete Buchung | {count} nicht zugeordnete Buchungen",
    autoTooltip: "Verteilt die Buchungen automatisch auf die Zimmer, sodass alle hineinpassen",
    organizing: "Wird geordnet…",
    organize: "Ordnen",
  },
  footer: {
    available: "Verfügbar",
    unavailable: "Nicht verfügbar",
    closed: "Geschlossen",
    overbookRisk: "Überbuchungsrisiko",
    realtime: "Die Werte werden in Echtzeit aktualisiert",
    timezone: "Zeitzone: {tz}",
  },
  dayEdit: {
    oneDay: "einen Tag",
    open: "Offen",
    closed: "Geschlossen",
    priceLabel: "Preis · Standardrate",
    minStayLabel: "Mindestaufenthalt (Nächte)",
    forSaleLabel: "Zimmer im Verkauf",
    forSaleHint: "Limit · max. {max}",
    applyMultiple: "Auf mehrere Daten anwenden?",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    save: "Speichern",
  },
  roomMenu: {
    create: "Buchung erstellen",
    createSub: "Buchung für den ausgewählten Zeitraum",
    block: "1 Zimmer sperren",
    blockSub: "Dieses Zimmer für den Zeitraum schließen",
    unblock: "Sperre aufheben",
    unblockSub: "Dieses Zimmer für den Zeitraum wieder öffnen",
    oos: "Außer Betrieb",
    oosSub: "Wartung für dieses Zimmer",
  },
  closureMenu: {
    turnoverTitle: "Durch die Wechselzeit festgelegt",
    turnoverSub: "Sie verschiebt sich mit den Buchungsdaten und entfällt bei einer Stornierung.",
    changeRule: "Regel ändern",
    changeRuleSub: "Wechselzeit anpassen oder deaktivieren",
    editReason: "Grund bearbeiten",
    editReasonSub: "Den Sperrgrund ändern",
    changeRoom: "Zimmer wechseln",
    changeRoomSub: "In ein anderes Zimmer dieses Typs verschieben",
    unblock: "Sperre aufheben",
    unblockSub: "Wieder öffnen und den Platz freigeben",
    moveTo: "Verschieben nach…",
    noOtherRooms: "Es gibt keine weiteren Zimmer dieses Typs.",
    barTooltip: "Sperre: {reason} · zum Bearbeiten oder Entfernen klicken",
  },
  typeConfig: {
    seasons: "Price seasons",
    seasonsSub: "Raise or lower prices by date",
    manageOta: "OTA-Verbindung verwalten",
    connectOta: "OTA verbinden",
    otaSub: "Die Unterkunft mit den OTAs synchronisieren",
    arrivalRules: "An- und Abreiseregeln",
    arrivalRulesSub: "Erlaubte Check-in-/Check-out-Tage",
  },
  // La habitación se ocupó unas HORAS, no una noche: en el calendario por
  // días se lee como un bloqueo con su motivo.
  hourly: {
    sold: "Stundenweise vermietet",
    soldOne: "Stundenweise vermietet · {range}",
    soldMany: "Stundenweise vermietet · {count} Aufenthalte",
  },
  tooltip: {
    past: "Vergangen",
    unassignedHtml: "<strong>Kein Zimmer zugewiesen.</strong> Die Verfügbarkeit verteilt sich auf die Zimmer. Nutzen Sie <strong>Ordnen</strong>, um sie automatisch neu zu verteilen, oder klicken Sie und weisen Sie ein Zimmer zu.",
    nights: "{count} Nacht | {count} Nächte",
    guests: "{count} Gast | {count} Gäste",
  },
  channels: {
    direct: "Direkt",
  },
  syncModal: {
    title: "Mit der OTA synchronisieren",
    message: "Verfügbarkeit und Höchstaufenthalt dieses Kalenders werden neu berechnet und erneut an die OTA gesendet.",
    confirm: "Ja, synchronisieren",
    cancel: "Abbrechen",
  },
  syncTooltip: {
    can: "Berechnet Verfügbarkeit und Höchstaufenthalt neu und sendet sie erneut an die OTA (verhindert Überbuchungen).",
    cannot: "Verbinden Sie die Unterkunft mit einem Kanal, um synchronisieren zu können.",
  },
  block: {
    editTitle: "Grund bearbeiten",
    createTitle: "Zimmer sperren",
    reasonLabel: "Sperrgrund",
    reasonHint: "(er wird im Kalender angezeigt)",
    placeholder: "z. B. Wartung, Eigennutzung…",
    cancel: "Abbrechen",
    saving: "Wird gespeichert…",
    saveReason: "Grund speichern",
    blockBtn: "Sperren",
    defaultReason: "Gesperrt",
    thisRoom: "dieses Zimmer",
    editReasonMsg: `Sperrgrund für „{room}“ ({count} Nacht) bearbeiten. | Sperrgrund für „{room}“ ({count} Nächte) bearbeiten.`,
    createMsg: `„{room}“ ({unit}) wird für {count} Nacht geschlossen. An diesen Daten ist das Zimmer nicht buchbar; die übrigen Zimmer dieses Typs bleiben verfügbar. | „{room}“ ({unit}) wird für {count} Nächte geschlossen. An diesen Daten ist das Zimmer nicht buchbar; die übrigen Zimmer dieses Typs bleiben verfügbar.`,
    presets: {
      maintenance: "Wartung",
      ownerUse: "Eigennutzung",
      renovation: "Renovierung",
      deepCleaning: "Grundreinigung",
      externalReserved: "Reserviert (extern)",
    },
  },
  organizeModal: {
    title: "Automatisch ordnen",
    bodyHtml: `Wir suchen die beste Kombination und <strong>verteilen die Buchungen neu auf die Zimmer</strong> dieses Typs, damit <strong>{count} nicht zugeordnete Buchung lückenlos passt</strong>. | Wir suchen die beste Kombination und <strong>verteilen die Buchungen neu auf die Zimmer</strong> dieses Typs, damit <strong>{count} nicht zugeordnete Buchungen lückenlos passen</strong>.`,
    point1Html: "Es ändert sich nur das zugewiesene <strong>physische Zimmer</strong>.",
    point2Html: "<strong>Daten, Preise und Gäste</strong> bleiben unverändert.",
    point3: "Wenn eine nicht lückenlos passt, sagen wir Ihnen Bescheid.",
    cancel: "Abbrechen",
    organizing: "Wird geordnet…",
    confirm: "Ja, ordnen",
  },
  empty: {
    noHotelTitle: "Keine Inserate vom Typ Hotel",
    noHotelSubHtml: "Legen Sie ein Inserat vom Typ <strong>Hotel</strong> oder <strong>Camping</strong> an, um die Verfügbarkeit pro Zimmer zu verwalten.",
    noHotelBtn: "Zu den Inseraten",
    noRoomsTitle: "{name} hat keine Zimmer",
    noRoomsSub: "Für dieses Inserat sind noch keine Zimmer angelegt. Fügen Sie in den Einstellungen des Inserats Zimmer hinzu, um den Kalender zu sehen.",
    noRoomsBtn: "Inserat einrichten",
  },
  mock: {
    today: "Heute",
    month: "MAI 2026",
    searchPlaceholder: "Nach Name oder Code suchen…",
    searchBtn: "Suchen",
    createBtn: "Buchung erstellen",
    na: "k. A.",
    forSaleLabel: "Verf. im Verkauf",
    suiteDeluxe: "Deluxe-Suite",
    standardRoom: "Standardzimmer",
    roomsCount2: "(2 Zimmer)",
    roomsCount3: "(3 Zimmer)",
    no: "Nr.",
    room101: "Zimmer 101",
    room102: "Zimmer 102",
    room201: "Zimmer 201",
    room202: "Zimmer 202",
    room203: "Zimmer 203",
    d1: "Mo 1",
    d2: "Di 2",
    d3: "Mi 3",
    d4: "Do 4",
    d5: "Fr 5",
    d6: "Sa 6",
    d7: "So 7",
    d8: "Mo 8",
    d9: "Di 9",
    d10: "Mi 10",
    d11: "Do 11",
    d12: "Fr 12",
  },
  ops: {
    closingDay: "Tag wird geschlossen…",
    openingDay: "Tag wird geöffnet…",
    saving: "Wird gespeichert…",
    movingBlock: "Sperre wird verschoben…",
    swappingBlockReservation: "Sperre und Buchung werden getauscht…",
    swappingReservationBlock: "Buchung und Sperre werden getauscht…",
    swappingRooms: "Zimmer werden getauscht…",
    changingRoom: "Zimmer wird gewechselt…",
    organizingRooms: "Zimmer werden geordnet…",
    syncingWithOta: "Kalender wird mit der OTA synchronisiert…",
    processing: "Wird verarbeitet…",
    settingMaintenance: "Wird in Wartung gesetzt…",
    clearingMaintenance: "Wartung wird aufgehoben…",
    updatingAvailability: "Verfügbarkeit wird aktualisiert…",
    updatingReason: "Grund wird aktualisiert…",
    closingRoom: "Zimmer wird geschlossen…",
    removingBlock: "Sperre wird entfernt…",
  },
  toasts: {
    dayClosed: "Tag geschlossen",
    dayOpened: "Tag geöffnet",
    availabilityUpdateErr: "Die Verfügbarkeit konnte nicht aktualisiert werden",
    dayUpdated: "Tag aktualisiert",
    daySaveErr: "Der Tag konnte nicht gespeichert werden",
    moveTargetMultipleReservations: "Das Ziel hat in diesem Zeitraum mehrere Buchungen; verschieben Sie sie manuell.",
    roomRejectsBlock: "Dieses Zimmer nimmt die Sperre in diesem Zeitraum nicht an",
    blockMoved: "Sperre in ein anderes Zimmer verschoben",
    blockMoveErr: "Die Sperre konnte nicht verschoben werden",
    swapStartErr: "Der Tausch konnte nicht gestartet werden",
    reservationNoFitSwap: "Die Buchung passt im anderen Zimmer nicht über den gesamten Zeitraum; sie konnte nicht getauscht werden.",
    reservationMoveErr: "Die Buchung konnte nicht verschoben werden",
    swapCompleteErr: "Der Tausch konnte nicht abgeschlossen werden (er wurde zurückgenommen)",
    blockReservationSwapped: "Sperre und Buchung getauscht",
    swapErr: "Der Tausch konnte nicht abgeschlossen werden",
    rangeHasOccupiedOrClosed: "Der Zeitraum enthält in diesem Zimmer belegte oder geschlossene Nächte.",
    organizeErr: "Es konnte nicht automatisch geordnet werden.",
    organizeNothing: "Es gab nichts neu zu ordnen.",
    organizePartial: "{done} Buchung(en) wurden geordnet, aber {unplaced} passen in keiner Kombination lückenlos.",
    organizeDoneAssigned: "Kalender geordnet: {assigned} zugewiesen",
    organizeDoneMoved: ", {moved} in ein anderes Zimmer verschoben",
    swapGroupDone: "Gruppentausch abgeschlossen: {groupCount} ⇄ {swappedCount} Buchungen.",
    roomsSwappedWith: "Zimmer mit {names} getauscht.",
    noPropertyToSync: "Es gibt keine Unterkunft zum Synchronisieren.",
    calendarResynced: "Kalender neu berechnet und mit der OTA synchronisiert.",
    syncErr: "Der Kalender konnte nicht mit der OTA synchronisiert werden.",
    genericError: "Fehler",
    reservationNoFitSwapStrict: "Der Tausch war nicht möglich: Die Buchung ist nicht über den gesamten Zeitraum frei.",
    reservationBlockSwapped: "Buchung und Sperre getauscht",
    roomCloseErr: "Das Zimmer konnte nicht geschlossen werden",
    reasonUpdated: "Grund aktualisiert",
    roomClosedInRange: "Zimmer für den Zeitraum geschlossen",
    blockRemoved: "Sperre entfernt",
    blockRemoveErr: "Die Sperre konnte nicht entfernt werden",
    searchMinChars: "Geben Sie mindestens 2 Zeichen für die Suche ein",
    searchNoResults: "Für diese Suche wurden keine Buchungen gefunden",
    searchErr: "Fehler bei der Buchungssuche",
  },
  summary: {
    stateAvailable: "Verfügbar",
    stateClosed: "Geschlossen",
    stateNoDisp: "k. A.",
  },
};
